(ns vit-configurator.events
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]
            [vit-configurator.db :as db]
            [vit-configurator.subs :as subs]))

(re-frame/reg-event-db
 ::initialize-db
 (fn [_ [_ opts]]
   (merge db/default-db opts)))

(re-frame/reg-event-db
 ::set-logo
 (fn [db [_ type optional-value]]
   (if (#{:state-seal :custom} type)
     (assoc db :logo {:type type :value optional-value})
     (assoc db :logo {:type type}))))

(re-frame/reg-event-db
 ::set-title
 (fn [db [_ title]]
   (if (str/blank? title)
     (dissoc db :title)
     (assoc db :title title))))

(re-frame/reg-event-db
 ::set-embedded-line1
 (fn [db [_ embedded-line1]]
   (if (str/blank? embedded-line1)
     (dissoc db :embedded-line1)
     (assoc db :embedded-line1 embedded-line1))))

(re-frame/reg-event-db
 ::set-embedded-line1-visibility
 (fn [db [_ embedded-line1-hidden]]
  (assoc db :embedded-line1-hidden embedded-line1-hidden)))

(re-frame/reg-event-db
 ::set-embedded-line2
 (fn [db [_ embedded-line2]]
   (if (str/blank? embedded-line2)
     (dissoc db :embedded-line2)
     (assoc db :embedded-line2 embedded-line2))))

(re-frame/reg-event-db
 ::set-embedded-line2-visibility
 (fn [db [_ embedded-line2-hidden]]
  (assoc db :embedded-line2-hidden embedded-line2-hidden)))

(re-frame/reg-event-db
 ::set-embedded-line3
 (fn [db [_ embedded-line3]]
   (if (str/blank? embedded-line3)
     (dissoc db :embedded-line3)
     (assoc db :embedded-line3 embedded-line3))))

(re-frame/reg-event-db
 ::set-embedded-line3-visibility
 (fn [db [_ embedded-line3-hidden]]
  (assoc db :embedded-line3-hidden embedded-line3-hidden)))

(re-frame/reg-event-db
 ::set-voter-info
 (fn [db [_ voter-info]]
   (if (str/blank? voter-info)
     (dissoc db :voter-info)
     (assoc db :voter-info voter-info))))

(re-frame/reg-event-db
 ::set-language
 (fn [db [_ lang]]
   (assoc db :language lang)))

(re-frame/reg-event-db
 ::set-official-only
 (fn [db [_ official]]
   (assoc db :official-only official)))

(re-frame/reg-event-db
 ::set-link-text
 (fn [db [_ link-kw text]]
   (if (str/blank? text)
     (update db :links dissoc link-kw)
     (assoc-in db [:links link-kw] text))))

(re-frame/reg-event-db
 ::set-summary-top-txt
 (fn [db [_ summary-top-txt]]
   (if (str/blank? summary-top-txt)
     (dissoc db :summary-top-txt)
     (assoc db :summary-top-txt summary-top-txt))))

(re-frame/reg-event-db
 ::set-summary-bottom-txt
 (fn [db [_ summary-bottom-txt]]
   (if (str/blank? summary-bottom-txt)
     (dissoc db :summary-bottom-txt)
     (assoc db :summary-bottom-txt summary-bottom-txt))))

(re-frame/reg-event-db
 ::set-summary-vote-by-mail-txt
 (fn [db [_ summary-vote-by-mail-txt]]
   (if (str/blank? summary-vote-by-mail-txt)
     (dissoc db :summary-vote-by-mail-txt)
     (assoc db :summary-vote-by-mail-txt summary-vote-by-mail-txt))))

(re-frame/reg-event-db
 ::set-summary-absentee-visibility
 (fn [db [_ summary-absentee-hidden]]
   (assoc db :summary-absentee-hidden summary-absentee-hidden)))

(re-frame/reg-event-db
 ::set-size
 (fn [db [_ size]]
   (assoc db :size size)))

(re-frame/reg-event-db
 ::set-search-box-type
 (fn [db [_ search-box-type]]
   (assoc db :search-box-type search-box-type)))

(re-frame/reg-event-fx
 ::preview-ready
 (fn [{:keys [db]} [_ preview]]
   {:db (-> db
            (assoc :preview-ready true)
            (assoc :preview-window preview))
    :dispatch [::send-config]}))

(re-frame/reg-event-fx
 ::send-config
 (fn [{:keys [db]} _]
   (when (:preview-ready db)
     (let [preview-window (:preview-window db)
           config (:config db)
           desktop-config (merge config {:display-mode "desktop"})
           event (clj->js {"config" desktop-config})]
       (.postMessage preview-window event)))
   {:db db}))

(re-frame/reg-event-db
 ::reload-preview
 (fn [db _]
   (let [preview-window (:preview-window db)
         location (.-location preview-window)]
     (.reload location)
     db)))

(re-frame/reg-event-db
 ::set-analytics
 (fn [db [_ mode]]
   (assoc db :analytics mode)))

(re-frame/reg-event-db
 ::set-analytics-custom
 (fn [db [_ tracker-name]]
   (if (str/blank? tracker-name)
     (dissoc db :analytics-custom)
     (assoc db :analytics-custom tracker-name))))

(defn add-language-code
  [m k]
  (if-let [v (get m k nil)]
    (-> m
        (dissoc k)
        (assoc-in (concat [k] [:en]) v))
    m))

(defn clj-config
  [db]
  (as->
      (select-keys db [:logo :language :size :search-box-type :title :embedded-line1 :embedded-line1-hidden :embedded-line2 :embedded-line2-hidden :embedded-line3 :embedded-line3-hidden :summary-top-txt :summary-bottom-txt :summary-vote-by-mail-txt :summary-absentee-hidden :links :voter-info :official-only]) $
      (add-language-code $ :title)
      (add-language-code $ :embedded-line1)
      (add-language-code $ :embedded-line2)
      (add-language-code $ :embedded-line3)
      (add-language-code $ :voter-info)
      (add-language-code $ :summary-top-txt)
      (add-language-code $ :summary-bottom-txt)
      (add-language-code $ :summary-vote-by-mail-txt)
      (add-language-code $ :links)
      (merge $
             (when (= :default (:analytics db))
               {:google-analytics-tracker true})
             (when (= :custom (:analytics db))
               {:google-analytics-tracker (:analytics-custom db)})
             (when (= :search (:search-box-type db))
               {:search-box-only? true}))))

(defn save-config-and-reload-preview
  [{:keys [db]} _]
  {:db (assoc db :config (clj-config db))
   :dispatch [::reload-preview]})

(re-frame/reg-event-fx ::save-config-and-reload-preview save-config-and-reload-preview)
